import { spawnWorker } from './internal/worker/index.js';

void spawnWorker();
